import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, SmartphoneIcon, TvIcon, TrophyIcon } from 'lucide-react';
export function DreamSection() {
  return <section className="bg-gradient-to-b from-zinc-950 via-emerald-950/20 to-zinc-950 py-16 sm:py-24" data-id="element-41">
      <div className="max-w-4xl mx-auto px-4" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-43">
          <SparklesIcon className="w-10 h-10 text-emerald-400 mx-auto mb-4" data-id="element-44" />
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4" data-id="element-45">
            Ahora imagina el{' '}
            <span className="text-emerald-400" data-id="element-46">otro escenario</span>
          </h2>
        </motion.div>

        {/* Dream scenario */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-gradient-to-br from-emerald-500/10 to-cyan-500/10 border border-emerald-500/20 rounded-2xl p-8 sm:p-10 mb-10" data-id="element-47">
          <p className="text-lg sm:text-xl text-zinc-300 leading-relaxed mb-6" data-id="element-48">
            Son las 9 de la noche.{' '}
            <span className="text-white font-semibold" data-id="element-49">Hay partido.</span> Abres
            Magis TV en tu Smart TV —{' '}
            <span className="text-emerald-400 font-semibold" data-id="element-50">
              que tú mismo instalaste
            </span>{' '}
            — y el canal ya está ahí, en vivo, en alta definición.
          </p>
          <p className="text-lg sm:text-xl text-zinc-300 leading-relaxed" data-id="element-51">
            Tu celular también lo tiene. Para cuando estás en el colectivo, en
            la sala de espera, en cualquier parte.
          </p>
        </motion.div>

        {/* Benefits grid */}
        <div className="grid sm:grid-cols-3 gap-6 mb-10" data-id="element-52">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 text-center" data-id="element-53">
            <TvIcon className="w-10 h-10 text-emerald-400 mx-auto mb-3" data-id="element-54" />
            <p className="text-white font-bold text-2xl mb-1" data-id="element-55">+1.000</p>
            <p className="text-zinc-400 text-sm" data-id="element-56">Canales internacionales</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 text-center" data-id="element-57">
            <SmartphoneIcon className="w-10 h-10 text-cyan-400 mx-auto mb-3" data-id="element-58" />
            <p className="text-white font-bold text-2xl mb-1" data-id="element-59">Android</p>
            <p className="text-zinc-400 text-sm" data-id="element-60">Celular + Smart TV</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 text-center" data-id="element-61">
            <TrophyIcon className="w-10 h-10 text-amber-400 mx-auto mb-3" data-id="element-62" />
            <p className="text-white font-bold text-2xl mb-1" data-id="element-63">Gratis</p>
            <p className="text-zinc-400 text-sm" data-id="element-64">Sin suscripciones mensuales</p>
          </motion.div>
        </div>

        {/* Emotional payoff */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-65">
          <p className="text-xl sm:text-2xl text-white font-medium leading-relaxed" data-id="element-66">
            Y lo mejor:{' '}
            <span className="text-emerald-400 font-bold" data-id="element-67">
              lo instalaste tú. Solo. Sin llamar a nadie.
            </span>
          </p>
          <p className="text-zinc-400 mt-4" data-id="element-68">
            Esa autonomía — ese pequeño orgullo de "yo pude" — vale mucho más
            que cualquier tutorial de YouTube.
          </p>
        </motion.div>
      </div>
    </section>;
}